module.exports = __webpack_public_path__ + "static/media/layout-6.69eb57b8.svg";